import React from "react";
import { ThemePalette, ThemeShadowSizes, ThemeAnimations } from "@vwpfs/mary-air-lib/theme/_Types";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { IconNames } from "@vwpfs/mary-air-lib/components/air/05-atoms/Icon";
import { Spinner } from "@vwpfs/mary-air-lib/components/air/06-molecules/Spinner";

/**
 *
 */
interface Props {
    isLoading: boolean;
    loadDownload: () => void;
    canDownloadFile: boolean;
}

/**
 *
 * @param props
 */
export const DownloadButtonCell: React.FC<Props> = (props) => (
    props.isLoading ? (
        <div style={{ paddingRight: "5px" }}>
            <Spinner active />
        </div>
    ) : (
        <Button
            icon={IconNames.DOWNLOAD}
            theme={{
                palette: ThemePalette.CONTRAST_PRIMARY,
                shadow: ThemeShadowSizes.TINY,
                animation: ThemeAnimations.GROW_IN,
            }}
            link={{ onClick: props.loadDownload }}
            disabled={props.canDownloadFile}
        />
    )
);
